import { useMemo } from "react";

import { useSelector } from "react-redux";
import { NavigationItem } from "@toolpad/core/AppProvider";

import { RootState } from "@store/store";
import { BaseLayout } from "@layouts/BaseLayout";

export const ReporteriaLayout = () => {
    const permissions = useSelector((state: RootState) => state.session.permissions);

    const navigationOptions = useMemo(() => {
        const options: NavigationItem[] = [];

        if (permissions.find((t) => t.module.code === "MRPYMIO")) {
            options.push({
                segment: "reporteria/solicitudes",
                title: "Solicitudes",
            });
        }

        if (permissions.find((t) => t.module.code === "MRECON")) {
            options.push({
                segment: "reporteria/reconsideraciones",
                title: "Reconsideraciones",
            });
        }

        return options;
    }, [permissions]);

    return <BaseLayout navigation={navigationOptions} />;
};
